import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Loader } from '@components/common';
import utils from '@utils';
import { APP_ENV } from '@config';
import { Badge } from 'react-bootstrap';
import moment from 'moment';
import useGetNonRKPayInvoiceList from './useGetNonRKPayInvoiceList';
import PaymentsContext from '../../../paymentsContext';

const NonRKPayInvoicesTable = ({ dispatch, filters, counts }) => {
	const [data, isLoading, error] = useGetNonRKPayInvoiceList(dispatch, filters, counts);
	const {
		setOfficerOrAgency, setLoadingNonRKPayInvoices, setTotalCount,
	} = useContext(PaymentsContext);
	const paymentsPortalUrl = APP_ENV === 'production' ? 'https://payments.rollkall.com/invoice/' : 'https://payments-portal.netlify.app/invoice/';

	const calculateTotalBalanceDue = (invoice) => utils.currencyFormatter(invoice.Total + invoice.Tax + invoice.ServiceFee);

	useEffect(() => {
		if (error) {
			utils.notify({
				type    : 'error',
				message : 'Error loading invoices.',
				title   : 'Oops',
			});
			setOfficerOrAgency('officer');
		}
	}, [error]);

	useEffect(() => {
		setLoadingNonRKPayInvoices(isLoading);
	}, [isLoading]);

	useEffect(() => {
		if (data) {
			setTotalCount(data.Count);
		}
	}, [data]);

	if (error) {
		return (
			<div>
				Error loading invoices
			</div>
		);
	}

	return (
		<div>
			<div className="table-responsive">
				<table className="table">
					<thead>
						<tr>
							<th>Invoice no.</th>
							<th>{' '}</th>
							<th>Issued Date</th>
							<th>Due Date</th>
							<th>Total balance</th>
							<th>{' '}</th>
						</tr>
					</thead>
					<tbody>
						<Choose>
							<When condition={isLoading}>
								<tr>
									<td colSpan="6" className="text-center paid-loader">
										<Loader active size="big" spinnerOnly />
									</td>
								</tr>
							</When>
							<When condition={data && data.Count === 0}>
								<tr>
									<td colSpan="6" className="text-center" style={{ padding : 0 }}>
										<div className="empty-state text-gray-light">No items.</div>
									</td>
								</tr>
							</When>
							<Otherwise>
								<For each="invoice" index="index" of={data.ItemList}>
									<tr key={invoice.Id}>
										<td>{invoice.InvoiceNumber}</td>
										<td>
											{invoice.IsEstimate && <Badge>Estimate</Badge>}
										</td>
										<td>{moment(invoice.IssueDate.replace(/T.+/, '')).format('ddd, MMM D, YYYY')}</td>
										<td>{moment(invoice.DueDate.replace(/T.+/, '')).format('ddd, MMM D, YYYY')}</td>
										<td>{calculateTotalBalanceDue(invoice)}</td>
										<td>
											<Choose>
												<When condition={invoice.Balance > 0}>
													<a
														target="_blank"
														rel="noopener noreferrer"
														className="btn btn-primary margin-right-10 btn btn-sm btn-default"
														href={`${paymentsPortalUrl}${invoice.PaymentToken}`}
													>
														Pay Now
													</a>
												</When>
												<Otherwise>
													<span className="btn-sm">✓ Paid</span>
												</Otherwise>
											</Choose>
										</td>
									</tr>
								</For>
							</Otherwise>
						</Choose>
					</tbody>
				</table>
			</div>
		</div>
	);
};

const mapStateToProps = (
	{
		payments : {
			counts,
			filters,
		},
	},
) => ({
	counts,
	filters,
});

NonRKPayInvoicesTable.propTypes = {
	filters  : PropTypes.object.isRequired,
	counts 	 : PropTypes.object.isRequired,
	dispatch : PropTypes.func.isRequired,
};

export default connect(mapStateToProps, null)(NonRKPayInvoicesTable);
